import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

import EditablePropsType from '../../../types/composer';
import themeSchema from './theme';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';

export type CTAProps = {
  caption: string;
  url: string;
  buttonColor?: string;
  rounded?: boolean;
  buttonIcon?: {
    icon: string;
    position: 'start' | 'end';
  };
  image?: string;
};

export const ctaIconsMap: Record<string, IconDefinition> = {
  'arrow-right': faArrowRight,
  'arrow-left': faArrowLeft,
  'chevron-right': faChevronRight,
  'chevron-left': faChevronLeft,
};

export const ctaSchema = {
  type: EditablePropsType.Object,
  label: 'CTA',
  name: 'cta',
  properties: {
    caption: {
      type: EditablePropsType.Text,
      name: 'caption',
      label: 'Caption',
    },
    url: {
      type: EditablePropsType.Text,
      name: 'url',
      label: 'URL',
    },
    buttonColor: {
      ...themeSchema,
      name: 'buttonColor',
      label: 'Button Color',
    },
    buttonIcon: {
      type: EditablePropsType.Object,
      name: 'buttonIcon',
      label: 'Button Icon',
      properties: {
        icon: {
          type: EditablePropsType.Select,
          name: 'icon',
          label: 'Icon',
          selectOptions: {
            options: [
              { label: '', value: '' },
              ...Object.keys(ctaIconsMap).map((val) => ({
                label: val,
                value: val,
              })),
            ],
          },
        },
        position: {
          type: EditablePropsType.Select,
          name: 'position',
          label: 'Position',
          selectOptions: {
            options: [
              { value: '', label: '' },
              { value: 'end', label: 'End' },
              { value: 'start', label: 'Start' },
            ],
          },
        },
      },
    },
  },
};

export const movableCtaSchema = {
  type: EditablePropsType.Object,
  label: 'Movable CTA',
  name: 'mcta',
  properties: {
    caption: {
      type: EditablePropsType.Text,
      name: 'caption',
      label: 'Caption',
    },
    url: {
      type: EditablePropsType.Text,
      name: 'url',
      label: 'URL',
    },
    buttonColor: {
      ...themeSchema,
      name: 'buttonColor',
      label: 'Button Color',
    },
    position: {
      type: EditablePropsType.Select,
      label: 'Position',
      name: 'position',
      selectOptions: {
        options: [
          {
            value: 'top',
            label: 'Top',
          },
          {
            value: 'bottom',
            label: 'Bottom',
          },
        ],
      },
    },
  },
};

export const ctasSchema = {
  label: 'CTAs',
  name: 'ctas',
  type: EditablePropsType.Array,
  items: ctaSchema,
};
